/**
 * The dashboards' "Avg delivery time" card, from the server's
 * avgDeliveryMinutes (utils/orderStats.js, one definition for every vendor
 * type). "-" when nothing has been delivered yet to average.
 */
export const formatAvgDelivery = (mins) => {
  const m = Number(mins) || 0;
  if (m <= 0) return "-";
  if (m < 60) return `${m} min`;
  return `${(m / 60).toFixed(1)} hrs`;
};

export default formatAvgDelivery;
